import React from 'react';
import Div100vh from 'react-div-100vh';
import View3D from '../view3D/View3D';
import { useDetailViewContext } from '../../context/DetailViewContext';
import DetailSidePanel from './WhiteModeSidePanel/WhiteModeSidePanel';
import DarkModeSidePanel from './DarkModeSidePanel/DarkModeSidePanel';
import FocusPoints from '../../data/FocusPoints';
import styles from './styles.module.scss';
import useWindowSize from '../../hooks/useWindowSize';

export default function DetailOverlay(): JSX.Element
{
  const { detailViewVisible, activeFocusID } = useDetailViewContext();
  const { height } = useWindowSize();

  return (
    <Div100vh 
      className={styles.detailOverlay} 
      data-visible={detailViewVisible}
      data-dark-mode={activeFocusID !== FocusPoints.None}
    >
      <View3D />
      {
        activeFocusID === FocusPoints.None 
          ? <DetailSidePanel />
          : <DarkModeSidePanel style={{ height: 0.6 * height}}/>
      }
    </Div100vh>
  );
}
